<div class="agentic-agent-grid">
  <button
    type="button"
    class="agentic-agent-card"
    *ngFor="let agent of agents; trackBy: trackByAgent"
    [class.selected]="agent.key === selectedAgentKey"
    [class.disabled]="agent.disabled"
    [disabled]="agent.disabled"
    [style.--agent-brand-color]="agent.brandColor"
    [style.--agent-score-color]="agent.scoreColor"
    (click)="selectAgent(agent.key)"
  >
    <div class="agent-card-top">
      <div class="agent-logo">
        <mat-icon>{{ agent.icon }}</mat-icon>
      </div>

      <div class="agent-title">
        <h2>{{ agent.label }}</h2>
        <p>{{ agent.provider }}</p>
      </div>

      <div class="agent-radio">
        <mat-icon *ngIf="agent.key === selectedAgentKey">check</mat-icon>
      </div>
    </div>

    <div class="agent-score-row">
      <div class="agent-score">
        <span>{{ agent.score }}</span>
        <small>/100</small>
      </div>
      <span class="agent-score-label">Visibility</span>
    </div>

    <div class="agent-progress">
      <span [style.width.%]="agent.score"></span>
    </div>

    <p class="agent-count" *ngIf="!agent.disabled">
      {{ agent.totalMatchedProducts }} of {{ agent.totalProducts }} products
      visible
    </p>
    <p class="agent-count unavailable" *ngIf="agent.disabled">
      No data available for this audit
    </p>
  </button>
</div>
